import { render, staticRenderFns } from "./banner-stand-modal.vue?vue&type=template&id=21b85da7"
import script from "./banner-stand-modal.vue?vue&type=script&lang=ts"
export * from "./banner-stand-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports